import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '@core/auth/auth.service';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule
  ],
  template: `
    <mat-toolbar class="header">
      <button
        mat-icon-button
        *ngIf="isHandset"
        (click)="drawer.toggle()"
        aria-label="Toggle menu"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <div class="brand hide-mobile">
        <img class="brand-logo" src="assets/images/logo.png" alt="Aethria Studio">
        <span class="title">AETHRIA STUDIO</span>
      </div>

      <span class="spacer"></span>

      <button
        mat-icon-button
        (click)="toggleTheme()"
        [matTooltip]="isDark ? 'Passer en mode clair' : 'Passer en mode sombre'"
        aria-label="Changer de thème"
      >
        <mat-icon>{{ isDark ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="User menu">
        <mat-icon>account_circle</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu">
        <div class="user-info" mat-menu-item disabled>
          <div class="user-name">{{ userProfile?.preferred_username }}</div>
          <div class="user-email">{{ userProfile?.email }}</div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Déconnexion</span>
        </button>
      </mat-menu>
    </mat-toolbar>
  `,
  styles: [`
    .header {
      position: sticky;
      top: 0;
      z-index: 1000;
    }

    .brand {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .brand-logo {
      width: 32px;
      height: 32px;
      object-fit: contain;
      border-radius: 8px;
      filter: drop-shadow(0 0 10px var(--accent-glow));
    }

    .title {
      font-family: var(--font-mono);
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.25em;
      color: var(--accent);
    }

    .spacer {
      flex: 1 1 auto;
    }

    .user-info {
      padding: 8px 16px;
      cursor: default;
    }

    .user-name {
      font-weight: 500;
      margin-bottom: 4px;
    }

    .user-email {
      font-size: 12px;
      color: var(--text-muted);
    }
  `]
})
export class HeaderComponent {
  @Input() drawer!: MatSidenav;
  @Input() isHandset: boolean | null = false;

  private authService = inject(AuthService);
  private themeService = inject(ThemeService);

  get userProfile() {
    return this.authService.getUserProfile();
  }

  get isDark(): boolean {
    return this.themeService.theme() === 'dark';
  }

  toggleTheme(): void {
    this.themeService.toggle();
  }

  logout(): void {
    this.authService.logout().subscribe();
  }
}
